module.exports = __webpack_public_path__ + "img/logo-white.3bd704b1.svg";